import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import getGeoLocationApi from '~/services/common/getGeoLocationApi';

export default function useGeolocation(): void {
  const {
    location: { setData }
  } = useContext(UserContext);
  const isLoggedIn = useIsLoggedIn();

  // Retrieve user's geolocation when their login status changes
  useSubsequentEffect(() => {
    getGeoLocationApi().getGeoLocation().then(setData);
  }, [isLoggedIn, setData]);
}
